import { configEnv } from '@libraries/config';

const seoConfig = {
  title: 'Octarine',
  description: 'Aplikasi WMS Octarine',
  openGraph: {
    type: 'website',
    locale: 'id_ID',
    url: configEnv.baseUrl,
    siteName: 'Octarine',
  },
  twitter: {
    handle: '@Octarine',
    site: '@Octarine',
    cardType: 'summary_large_image',
  },
};

export default seoConfig;
